export const FeatureFlags = {
  FNXAIDIProcess: 'fnx-aidi-process-v-2',
  HideTerminationDate: 'hide-termination-date',
  FNXHideSherpa: 'fnx-hide-sherpa',
  EnableDynamicQuestionnaire: 'enable-dynamic-questionnaire',
  HideLegalContacts: 'fnx-hrx-hide-legal-contacts',
};
